import { t } from '@procumi/shared';
import type { MarketProduct } from '@procumi/shared';
import { Change, price } from './PriceMarks';

/**
 * Banda „Mișcări de preț”, ca la bursă: materialele cerute recent, cu cel mai
 * mic preț de acum, săgeata și furnizorul. Curge încet și se oprește sub mouse;
 * cine a cerut mișcare redusă o vede pe loc (CSS). Lista e pusă de două ori la
 * rând, ca derularea să nu aibă capăt.
 */
export function PriceBand({
  products,
  onPick,
}: {
  products: MarketProduct[];
  onPick: (key: string) => void;
}) {
  if (!products.length) return null;
  const roll = products.length >= 4;
  const item = (p: MarketProduct, copy: boolean) => (
    <button
      type="button"
      key={`${copy ? 'b' : 'a'}-${p.key}`}
      className="pb-it"
      onClick={() => onPick(p.key)}
      tabIndex={copy ? -1 : undefined}
      aria-hidden={copy || undefined}
    >
      <span className="n">{p.desc}</span>
      <b>{price(p.now)}</b>
      <span className="u">{t('lei/{0}', p.unit)}</span>
      <Change v={p.change} />
      <span className="u">· {p.pick.name}</span>
    </button>
  );
  return (
    <section className="pb" aria-label={t('Mișcările de preț de la ultimele cereri')}>
      <div className="pb-k">
        {t('Mișcări de preț')}
        <small>{t('la ultimele cereri')}</small>
      </div>
      <div className="pb-v">
        <div className={`pb-track${roll ? ' roll' : ''}`}>
          {products.map((p) => item(p, false))}
          {roll ? products.map((p) => item(p, true)) : null}
        </div>
      </div>
    </section>
  );
}
